var _g, _path, _rect, _rect2, _path2, _circle, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoachingCall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 104,
    viewBox: "0 0 120 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14.8201,
    y: 10.2393,
    width: 90.2817,
    height: 75.7397,
    rx: 5,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8201 15.2393C14.8201 12.4778 17.0586 10.2393 19.8201 10.2393H100.102C102.863 10.2393 105.102 12.4778 105.102 15.2393V22.3576H14.8201V15.2393ZM90.5597 16.2985C90.5597 17.6371 89.4746 18.7222 88.1361 18.7222C86.7975 18.7222 85.7124 17.6371 85.7124 16.2985C85.7124 14.96 86.7975 13.8749 88.1361 13.8749C89.4746 13.8749 90.5597 14.96 90.5597 16.2985ZM32.3918 18.7222C33.7304 18.7222 34.8155 17.6371 34.8155 16.2985C34.8155 14.96 33.7304 13.8749 32.3918 13.8749C31.0533 13.8749 29.9681 14.96 29.9681 16.2985C29.9681 17.6371 31.0533 18.7222 32.3918 18.7222Z",
    fill: "#E24C4C"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 31.18,
    y: 4.17969,
    width: 2.42367,
    height: 12.1183,
    rx: 1.21183,
    fill: "#DFDFDF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 86.9243,
    y: 4.17969,
    width: 2.42367,
    height: 12.1183,
    rx: 1.21183,
    fill: "#DFDFDF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7513 55.3367L55.8406 62.3481L72.3821 45.9883",
    stroke: "white",
    strokeWidth: 6,
    strokeLinecap: "square"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60.7769,
    cy: 53.7656,
    r: 17.501,
    fill: "#00B288"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5913 56.6406C66.5449 56.6406 65.5325 56.4704 64.5882 56.1642C64.2904 56.0621 63.9586 56.1386 63.7289 56.3683L62.3932 58.0443C59.9856 56.8958 57.7312 54.7264 56.5316 52.2337L58.1906 50.8215C58.4203 50.5833 58.4883 50.2515 58.3948 49.9538C58.08 49.0094 57.9183 47.997 57.9183 46.9506C57.9183 46.4912 57.5355 46.1084 57.0761 46.1084H54.1325C53.6731 46.1084 53.1202 46.3126 53.1202 46.9506C53.1202 54.854 59.6964 61.4217 67.5913 61.4217C68.1953 61.4217 68.4335 60.8858 68.4335 60.4179V57.4828C68.4335 57.0234 68.0507 56.6406 67.5913 56.6406Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0.820068,
    y: 0.239258,
    width: 118.282,
    height: 103.74,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoachingCall);
export default __webpack_public_path__ + "static/media/coaching-call.b7e05505.svg";
export { ForwardRef as ReactComponent };